import { useQuery } from "convex/react";
import { Bookmark, Hash } from "lucide-react";
import { api } from "../../../../convex/_generated/api";
import { Dialog } from "../ui/Dialog";

export function SavedMessagesDialog({ onClose, onOpen }: { onClose: () => void; onOpen: (conversationId: string) => void }) {
  const saved = useQuery(api.communication.listSavedMessages, {});
  return (
    <Dialog title="Saved messages" onClose={onClose} wide>
      <div className="saved-message-list">
        {saved === undefined ? <p className="loading-hint">Loading saved messages…</p> : saved.length === 0 ? <div className="empty-state"><Bookmark size={22} /><h3>Nothing saved yet</h3><p>Use the bookmark button on any message to keep it here.</p></div> : saved.map((item) => <button key={`${item.message.id}-${item.savedAt}`} type="button" onClick={() => { onOpen(item.conversationId); onClose(); }}><span><Hash size={13} /> {item.conversationName}</span><strong>{item.message.author.displayName}</strong><p>{item.message.content.plainText}</p><time>{new Date(item.savedAt).toLocaleString()}</time></button>)}
      </div>
    </Dialog>
  );
}
